export default "__VITE_ASSET__20c26ad3__"